import * as UnboundFlashMessageActions from 'shared/actions/UnboundFlashMessageActions';
import { SubmissionError } from 'utils/reduxFormWrapper';

const buildRejectionHandler = (dispatch, history) => {
  const defaultErrorHandlers = {
    // Unauthorzed
    401: (response, error) => {
      if (response.data && response.data.loginUrl) {
        window.location.replace(response.data.loginUrl);
        error.handled = true;
      } else {
        dispatch(
          UnboundFlashMessageActions.flashError({
            message:
              "I'm sorry, you must be logged in to access that. Please try logging in first.",
          })
        );
      }
    },
    // Forbidden
    403: response => {
      switch (response.data.errorCode) {
        case 'invalid_csrf':
          dispatch(
            UnboundFlashMessageActions.flashError({
              message:
                "I'm sorry, we were unable to complete that request because the page was stale. Please refresh and try again.",
            })
          );
          break;
        case 'inactive':
          window.location = response.data.redirectUrl;
          break;
        case 'change_password':
          dispatch(
            UnboundFlashMessageActions.flashWarning({
              message: 'Before you continue, please update your password',
            })
          );
          history.push(response.data.redirectUrl);
          break;
        case 'not_logged_in':
        default:
          dispatch(
            UnboundFlashMessageActions.flashError({
              message: "I'm sorry, you are not authorized to view that.",
            })
          );
      }
    },
    // Unprocessable Entity
    422: response => {
      if (response.data.errors) {
        const camelizedErrors = response.data.errors;
        const errors = {};

        // For any given error, duplicate it at a key with the same name with 'Id' appended
        // (e.g. error for 'role', will also be an error for 'roleId')
        Object.keys(camelizedErrors).forEach(errorKey => {
          errors[errorKey] = camelizedErrors[errorKey];
          if (errorKey.slice(-2) !== 'Id') {
            errors[`${errorKey}Id`] = camelizedErrors[errorKey];
          }
        });
        dispatch(
          UnboundFlashMessageActions.flashError({ message: 'Please double-check for omissions.' })
        );
        throw new SubmissionError(errors);
      } else if (response.data.fullErrorMessages) {
        dispatch(
          UnboundFlashMessageActions.flashError({ message: 'Please double-check for omissions.' })
        );
        throw new SubmissionError({ _error: response.data.fullErrorMessages });
      } else {
        defaultErrorHandlers.default(response);
      }
    },
    // All other error HTTP codes...
    default: response => {
      if (response.data.errorMessage) {
        dispatch(UnboundFlashMessageActions.flashError({ message: response.data.errorMessage }));
      } else {
        dispatch(
          UnboundFlashMessageActions.flashError({
            message: "I'm sorry, something went wrong. Please refresh and try again.",
          })
        );
      }
    },
  };

  const rejectionHandler = error => {
    if (error.message === 'Network Error') {
      dispatch(
        UnboundFlashMessageActions.flashError({
          message:
            "I'm sorry, your internet connection seems to be missing. Please reconnect and try again.",
        })
      );
      throw error;
    }
    const { response } = error;
    if (response) {
      if (response.status && defaultErrorHandlers[response.status]) {
        defaultErrorHandlers[response.status](response, error);
      } else {
        defaultErrorHandlers.default(response);
      }
    } else {
      dispatch(
        UnboundFlashMessageActions.flashError({
          message: "I'm sorry, something went wrong. Please refresh and try again.",
        })
      );
    }
    throw error;
  };

  return rejectionHandler;
};

export default buildRejectionHandler;
